var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"stroke-linejoin":"round","stroke-width":"1.5","d":"M22 7 12 2 2 7v10l10 5 10-5z"}}),_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"m2 7 10 5M12 22V12M22 7l-10 5M17 4.5l-10 5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }